import ScalarSidebarGroupToggle_default from "./ScalarSidebarGroupToggle.vue.js";
import { cva, useBindCx } from "@scalar/use-hooks/useBindCx";
import { createElementBlock, createSlots, createVNode, defineComponent, mergeProps, openBlock, renderSlot, unref, withCtx } from "vue";
//#region src/components/ScalarSidebar/ScalarSidebarGroupToggleButton.vue?vue&type=script&setup=true&lang.ts
var _hoisted_1 = ["aria-expanded"];
var ScalarSidebarGroupToggleButton_vue_vue_type_script_setup_true_lang_default = /*@__PURE__*/ defineComponent({
	inheritAttrs: false,
	__name: "ScalarSidebarGroupToggleButton",
	props: {
		open: {
			type: Boolean,
			default: false
		},
		selected: { type: Boolean }
	},
	setup(__props) {
		const variants = cva({
			base: ["absolute top-[1lh] right-1 -translate-y-1/2", "rounded p-1 text-sidebar-c-2"],
			variants: { selected: {
				true: "hover:bg-sidebar-b-1 hover:text-sidebar-c-1",
				false: "hover:bg-sidebar-b-hover hover:text-sidebar-c-hover"
			} },
			defaultVariants: { selected: false }
		});
		const { cx } = useBindCx();
		return (_ctx, _cache) => {
			return openBlock(), createElementBlock("button", mergeProps({
				"aria-expanded": __props.open,
				type: "button"
			}, unref(cx)(unref(variants)({ selected: __props.selected }))), [renderSlot(_ctx.$slots, "default", { open: __props.open }, () => [createVNode(ScalarSidebarGroupToggle_default, { open: __props.open }, createSlots({ _: 2 }, [_ctx.$slots.label ? {
				name: "label",
				fn: withCtx(() => [renderSlot(_ctx.$slots, "label", { open: __props.open })]),
				key: "0"
			} : void 0]), 1032, ["open"])])], 16, _hoisted_1);
		};
	}
});
//#endregion
export { ScalarSidebarGroupToggleButton_vue_vue_type_script_setup_true_lang_default as default };

//# sourceMappingURL=ScalarSidebarGroupToggleButton.vue.script.js.map